<template>
  <v-container grid-list-md fluid>
    <v-btn
      v-if="appointment.status !== 'done'"
      fixed
      right
      bottom
      dark
      @click="markDone"
      color="primary"
      style="z-index:999;"
    >
      Mark as done
      <v-icon dark right>mdi-check</v-icon>
    </v-btn>
    <v-layout row wrap>
      <!-- Patient Info -->
      <v-flex xs12>
        <div class="section-title mt-0 di-flex justify-space-between align-center">
          <div>Patient Information</div>
        </div>

        <v-layout row wrap mt-3>
          <v-flex xs12 sm6 md3>
            <label class="mx-2 font-weight-bold">Name:</label>
            <span class="text-capitalize">{{appointment.patient.name}}</span>
          </v-flex>
          <v-flex xs12 sm6 md3>
            <label class="mx-2 font-weight-bold">Age:</label>
            <span>{{appointment.patient.age}}</span>
          </v-flex>
          <v-flex xs12 sm6 md3>
            <label class="mx-2 font-weight-bold">Gender:</label>
            <span class="text-capitalize">{{appointment.patient.gender}}</span>
          </v-flex>
          <v-flex xs12 sm6 md3>
            <label class="mx-2 font-weight-bold">Phone:</label>
            <span>{{appointment.patient.phone}}</span>
          </v-flex>
          <v-flex xs12>
            <label class="mx-2 font-weight-bold">Address:</label>
            <span class="text-capitalize">{{appointment.patient.address}}</span>
          </v-flex>

          <v-flex xs12 px-3 pt-3>
            <v-textarea
              @keyup.shift.enter="saveNote"
              rows="3"
              label="Patient Notes [Edit & Shift + Enter to save]"
              v-model="appointment.patient.notes"
            ></v-textarea>
          </v-flex>
        </v-layout>
      </v-flex>

      <!-- Prescriptions -->
      <prescriptions class="mt-4" :patient="appointment.patient" @refresh="getAppointment" />

      <!-- Lab Tests -->
      <lab-tests class="mt-4" :patient="appointment.patient" @refresh="getAppointment" />

      <!-- Procedures -->
      <procedures class="mt-4 mb-5" :patient="appointment.patient" @refresh="getAppointment" />
    </v-layout>
  </v-container>
</template>

<script>
import Prescriptions from "./prescriptions.vue";
import LabTests from "./tests.vue";
import Procedures from "./procedures.vue";
export default {
  // layout: "single",
  middleware: "doctor",
  components: {
    LabTests,
    Procedures,
    Prescriptions
  },
  data() {
    return {
      appointment: {
        patient: {}
      }
    };
  },

  methods: {
    saveNote() {
      if (!this.appointment.patient.notes) return;

      this.axios
        .put(`/api/patients/${this.appointment.patient.id}/add_note`, {
          note: this.appointment.patient.notes
        })
        .then(resp => {
          console.log(resp.data);
        });
    },
    getAppointment() {
      this.axios
        .get(`/api/appointments/${this.$route.params.id}`)
        .then(resp => {
          this.appointment = resp.data.data;
        });
    },
    markDone() {
      this.axios
        .put(`/api/appointments/${this.appointment.id}/status?status=done`)
        .then(resp => {
          this.appointment = resp.data.data;
        });
    }
  },

  watch: {
    appointment(val) {
      if (val.status === "paid") {
        this.axios
          .put(`/api/appointments/${val.id}/status?status=seen`)
          .then(resp => {
            this.appointment = resp.data.data;
          });
      }
    }
  },

  mounted() {
    this.getAppointment();
  }
};
</script>